import css from './sass/style.scss';

require('./js/accordion.js');
require('./js/anims.js');
require('./js/benefits.js');
require('./js/carousels.js');
require('./js/cookies.js');
require('./js/facts.js');
require('./js/flybar.js');
require('./js/fonts.js');
require('./js/glightbox.js');
require('./js/helpers.js');
require('./js/hero.js');
require('./js/init.js');
require('./js/inview.js');
require('./js/ismobile.js');
require('./js/join.js');
require('./js/lazy.js');
require('./js/nav.js');
require('./js/numbers.js');
require('./js/offers.js');
require('./js/polyfills.js');
require('./js/presenter.js');
require('./js/progress.js');
require('./js/showmore.js');
require('./js/smoothscroll.js');
require('./js/subscribe.js');
require('./js/video.js');
